import { useLayoutEffect } from 'react';

// Locks page scroll while mounted. Saves and restores the body's *inline* overflow value —
// reading getComputedStyle instead captures other active scroll locks
// (e.g. antd's `html body { overflow-y: hidden }` stylesheet while a modal is open)
// and re-applies them as a permanent inline style on unmount, leaving the page scroll stuck.
export default function LockBodyScroll() {
  useLayoutEffect(() => {
    const { body } = document;
    const originalOverflow = body.style.overflow;
    body.style.overflow = 'hidden';
    return () => {
      body.style.overflow = originalOverflow;
    };
  }, []);
  return null;
}
